<template>
  <div class="profile">
    <!-- 无数据 -->
    <div class="ws-box column aCenter" v-show="msg">
      <img class="ws-img" src="../../assets/img/img_wanshan.png" alt="" />
      <div class="ws-btn" @click="complateMsg">完善您的个人信息</div>
    </div>
    <div v-show="!msg">
      <div class="czjl">完善您的个人信息</div>
      <div class="msg-box">
        <div class="msg-box-item flex aCenter">
          <div class="flex aCenter">
            <img src="../../assets/img/icon_qyxx.png" alt="" />
            <div class="text">您的姓名</div>
          </div>
          <el-input
            style="width: 420px; margin-left: 92px"
            v-model="name"
            placeholder="请输入姓名"
          ></el-input>
          <div class="fsyx-btn" @click="editname">确认修改</div>
        </div>
        <div class="msg-box-item flex aCenter">
          <div class="flex aCenter">
            <img src="../../assets/img/icon_phone.png" alt="" />
            <div class="text">手机号</div>
          </div>
          <el-input
            style="width: 420px; margin-left: 92px"
            v-model="phone"
            placeholder="请输入手机号"
          ></el-input>
          <div class="fsyx-btn" @click="editphone">确认修改</div>
        </div>
        <div class="msg-box-item flex aCenter">
          <div class="flex aCenter">
            <img src="../../assets/img/icon_youxiang_black.png" alt="" />
            <div class="text">邮箱</div>
          </div>
          <el-input
            style="width: 420px; margin-left: 92px"
            v-model="email"
            placeholder="请输入邮箱"
          ></el-input>
          <div class="fsyx-btn" @click="dialogFormVisible = true">确认修改</div>
          <!-- <div class="fsyx-btn">已发送</div>
          <div class="fsyx-btn">发送激活邮箱</div> -->
        </div>
        <div class="msg-box-item flex aCenter">
          <div class="flex aCenter">
            <img src="../../assets/img/icon_mima_black.png" alt="" />
            <div class="text">密码</div>
          </div>
          <el-input
            style="width: 420px; margin-left: 92px"
            v-model="pass"
            type="password"
            placeholder="请输入密码"
          ></el-input>
          <div class="fsyx-btn" @click="dialogFormVisible2 = true">
            确认修改
          </div>
        </div>
        <!-- <div class="wc-btn-no">完成</div> -->
        <!-- <div class="wc-btn">完成</div> -->
      </div>
    </div>
    <!-- 邮箱弹窗 -->
    <el-dialog title="修改邮箱" :visible.sync="dialogFormVisible" center>
      <div class="msg-box-item flex aCenter">
        <div class="flex aCenter">
          <div class="text">邮箱</div>
        </div>
        <el-input
          style="width: 420px"
          v-model="nwe_email"
          placeholder="请输入新的邮箱"
        ></el-input>
        <div class="fsyx-btn" @click="getcode">{{ codetext }}</div>
      </div>
      <div class="msg-box-item flex aCenter">
        <div class="flex aCenter">
          <div class="text">验证码</div>
        </div>
        <el-input
          style="width: 420px"
          v-model="yzm"
          placeholder="请输入验证码"
        ></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editemail">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible2" center>
      <div class="msg-box-item flex aCenter jCenter">
        <div class="flex aCenter">
          <div class="text">旧密码</div>
        </div>
        <el-input
          style="width: 420px"
          v-model="old_pwd"
          placeholder="请输入旧密码"
        ></el-input>
      </div>
      <div class="msg-box-item flex aCenter jCenter">
        <div class="flex aCenter">
          <div class="text">新密码</div>
        </div>
        <el-input
          style="width: 420px"
          v-model="nwe_pass"
          placeholder="请输入新的密码"
        ></el-input>
      </div>
      <div class="msg-box-item flex aCenter jCenter">
        <div class="flex aCenter">
          <div class="text">确认密码</div>
        </div>
        <el-input
          style="width: 420px"
          v-model="re_pwd"
          placeholder="请输入再次输入新的密码"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="editpass">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMselfApi } from "../../network/api";

import Index from "./Index";
export default {
  name: "Profile",
  mixins: [Index],
  created() {
    let token = this.$store.state.userinfo.token;
    getMselfApi(token)
      .then((res) => {
        // console.log(res);
        this.name = res.data.data.real_name;
        this.email = res.data.data.email;
        this.phone = res.data.data.phone;
        if (this.name == "" || this.email == "" || this.phone == "") {
          this.msg = true;
        } else {
          this.msg = false;
        }
      })
      .catch();
  },
};
</script>
<style scoped src="./Profile.css"></style>
